export { default as MainLayoutTemplate } from './MainLayoutTemplate';
export { default as PublicLayoutTemplate } from './PublicLayoutTemplate';
export { default as MasterLayoutTemplate } from './MasterLayoutTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/layouts/index.js